import React from "react";

export default function MySQL_SQRT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_SQRT</h1>
      <p>This is the MySQL_SQRT component generated from the SQL JSON.</p>
    </div>
  );
}
